import styled from 'styled-components'
import { Label } from '../text/Text'
import { FlexColumn } from '../layout/FlexContainer'

const styles = {
  label: { fontSize: '10px' },
}

const Container = styled(FlexColumn)`
  align-items: ${p => p.align};
  position: relative;
  ${p => p.marginRight && `margin-right: ${p.marginRight}px;`}
`

export const FieldDetail = ({
  children = false,
  contentStyle = {},
  name,
  className,
  align = 'flex-start',
  marginRight = 0,
  styleLabel = {},
}) => {
  return (
    <Container className={className} align={align} marginRight={marginRight}>
      <div style={styleLabel}>
        <Label style={styles.label}>{name}</Label>
      </div>
      <div style={contentStyle} className="flex flex-col items-center justify-center">
        {children}
      </div>
    </Container>
  )
}
